/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { ServiceObjectPartnerV1Dto } from './ServiceObjectPartnerV1Dto';
export type ServiceObjectPartnerRelationShortV1Dto = {
  /**
   * The unique identifier of the entity.
   */
  readonly id: string;
  /**
   * The current version of the entity
   */
  version: number;
  /**
   * The partner associated with the service object along with their details
   */
  partner: ServiceObjectPartnerV1Dto;
  /**
   * Role of the partner associated with the service object, can be either Landlord, Maintenance or Partner
   */
  role: ServiceObjectPartnerRelationShortV1Dto.role;
};
export namespace ServiceObjectPartnerRelationShortV1Dto {
  /**
   * Role of the partner associated with the service object, can be either Landlord, Maintenance or Partner
   */
  export enum role {
    LANDLORD = 'Landlord',
    MAINTENANCE = 'Maintenance',
    PARTNER = 'Partner',
  }
}
